import { StyleSheet, Text, View, ActivityIndicator } from 'react-native'
import React from 'react'
import { ActionButton, LabledTextField } from '../SharedWidgets/LoginAndSignup';
import { useUpdatePasswordStore } from './UpdatePasswordStore';

export default function UpdatePasswordScreen() {

    const { oldPassword, setOldPassword, newPassword,
        setNewPassword, confirmNewPassword,
        setConfirmNewPassword,
        showOldPassword, toggleShowOldPassword,
        showConfirmedPassword,
        toggleShowConfirmedPassword,
        showNewPassword,
        toggleShowNewPassword,
        handleSubmit,
        showSpinner,
    } =
        useUpdatePasswordStore();

    async function handleBtn() {
        handleSubmit(() => {
            console.log("passwordupdate");
        })
    }

    return (
        <View style={styles.root}>
            <Text
                style={{ fontFamily: 'Poppins_700Bold', fontSize: 24, textAlign: "center" }}
            >
                Update Password
            </Text>

            <LabledTextField
                hint='Enter Old Password'
                title='Old Password'
                useEye={true}
                value={oldPassword}
                onValueChange={setOldPassword}
                eyeState={showOldPassword}
                toggleEye={toggleShowOldPassword}
            />

            <LabledTextField
                hint='Enter New Password'
                title='New Password'
                useEye={true}
                value={newPassword}
                onValueChange={setNewPassword}
                eyeState={showNewPassword}
                toggleEye={toggleShowNewPassword}
            />

            <LabledTextField
                hint='Confirm New Password'
                title='Confirm New Password'
                useEye={true}
                value={confirmNewPassword}
                onValueChange={setConfirmNewPassword}
                eyeState={showConfirmedPassword}
                toggleEye={toggleShowConfirmedPassword}
            />

            <ActionButton
                label='Update Password'
                onClick={handleBtn}
            />

            {showSpinner &&
                <ActivityIndicator
                    size="large"
                    color="#007AFF"
                />}


        </View>
    )
}

const styles = StyleSheet.create({
    root: {
        backgroundColor: "white",
        flex: 1,
        gap: 12,
        paddingHorizontal: 12,
        paddingVertical: 12,
    }
});